/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import qs from 'qs';
import CustomSearch from '@reedexpo/custom-search';
import utils from './utils';
import ParticipantItem from '../common/components/ParticipantItem';
import Tags from '../common/dtmTags';
import CommonService from '../common/api/CommonService';
import TranslationService from '../translations';
import InlineLoginError from '../common/components/InlineLoginError';
import authorizationStore from '../common/api/authorizationStore';
import { AlgoliaConstants, NetworkingFacet, PPSSortOrder } from '../common/Constants';
import Algolia from './AlgoliaSearchWrapper';
import logger from '../logger';
import AlgoliaTokenService from './AlgoliaTokenService';
import { isNewAlgoliaIndexEnabled } from '../common/eventEditions';

const refineQueryState = (searchStateQuery) => qs.parse(searchStateQuery).query;
const refineSearchQueryState = (searchStateQuery) => qs.parse(searchStateQuery).search;
const getQueryStringFromUrl = () => window.location.search.slice(1);
let existingFacetingAttributes = [];
let loggerInstance;

class AlgoliaWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      label: 'shortDescription',
      id: 'id',
      nestedKey: 'answers',
      dtmPrefix: 'participantDirectory',
      hasMore: true,
      pageStart: -1,
      resetPage: 0,
      selectedFilter: [],
      filterQuery: '',
      hits: [],
      searchState: { query: refineQueryState(getQueryStringFromUrl()) },
      hasError: false,
      sortValue: null,
      sortOptions: null,
      hasFilterOnlyApplied: false,
      total: 0
    };
    loggerInstance = logger.getLogger(this.props.baseApiUrl);
  }

  index = null;

  client = null;

  defaultSortOrder = 'lastNameAsc';

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    const {
      appId, indexName, apiKey, context
    } = this.props;
    this.client = Algolia.search(appId, apiKey);
    this.index = this.client.initIndex(indexName);
    const sortOptionsTranslation = TranslationService.getTranslations(context.interfaceLocale).directory.sortOptions;

    this.index.getSettings().then((settings) => {
      existingFacetingAttributes = settings.attributesForFaceting;
      this.setSortOptions(settings.replicas, sortOptionsTranslation);
      this.setAlgoliaIndexFromUrlSortOption(settings.replicas);
      if (getQueryStringFromUrl().includes('refinementList')) {
        this.fetchFilterData().then((result) => {
          this.setState({ filterQuery: utils.refineFiltersFromQueryString(getQueryStringFromUrl(), result.facets) }, () => this.resetPage());
        });
      } else {
        this.resetPage();
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.apiKey !== prevProps.apiKey) {
      const logMessage = `previous algolia id :${prevProps.apiKey} new algolia id ${this.props.apiKey}`;
      logger.logInfo(logMessage, logMessage, this.props.baseApiUrl);
      this.setAlgoliaClient();
    }
  }

  onSearch = (searchInput) => this.setState(
    {
      resetPage: Math.random(),
      hits: [],
      hasMore: true,
      searchState: { query: searchInput }
    },
    () => {
      this.onSearchStateChange();
    }
  );

  setSortOptions = (replicas, translation) => {
    const { indexName } = this.props;
    const dtmTags = Tags.participantDirectory.sortOptions;
    let options = replicas ? replicas.map((x) => {
      const value = x.split('_').slice(-1)[0];
      return { value, label: translation[value], dtmTag: dtmTags[value] };
    }) : [];
    options = options.filter((option) => option.label);
    const defaultValue = { value: indexName, label: translation[this.defaultSortOrder], dtmTag: dtmTags[this.defaultSortOrder] };
    const sortValueFromUrl = qs.parse(getQueryStringFromUrl()).sort;
    const shouldUseDefaultSortOrder = !sortValueFromUrl || sortValueFromUrl === 'default' || !replicas.includes(`${indexName}_${sortValueFromUrl}`);
    const initialSortOrder = shouldUseDefaultSortOrder
      ? defaultValue : { value: sortValueFromUrl, label: translation[sortValueFromUrl], dtmTag: dtmTags[sortValueFromUrl] };
    this.setState({ sortOptions: [defaultValue].concat(options), sortValue: initialSortOrder });
  };

  setAlgoliaIndexFromUrlSortOption = (replicaIndices) => {
    const { indexName } = this.props;
    const sortValueFromUrl = qs.parse(getQueryStringFromUrl()).sort;
    const replicaIndexName = `${indexName}_${sortValueFromUrl}`;
    if (!sortValueFromUrl || sortValueFromUrl === 'default') {
      return;
    }
    if (!replicaIndices.includes(replicaIndexName)) {
      this.updateUrlWithSortValue('default');
      return;
    }

    this.index = this.client.initIndex(replicaIndexName);
  };

  fetchFilterData = () => {
    this.setState({ hasMore: false });
    const { eventEditionId, context } = this.props;
    const isNewIndex = isNewAlgoliaIndexEnabled(eventEditionId);
    return new Promise((resolve, reject) => {
      const filterData = {
        hitsPerPage: 0,
        facets: '*'
      };
      if (isNewIndex) {
        filterData.filters = `locale:${context.interfaceLocale.toLowerCase()} AND eventEditionId:${eventEditionId}`;
      }
      this.index.search(
        filterData,
        (err, content) => {
          if (err) {
            reject(err);
          }
          const data = utils.parseFilterData(content.facets, this.props.networkFollowees);
          const filtersData = utils.parseFilterJson(data, this.state);
          const sortedPPS = sortBy(filtersData, [PPSSortOrder]);
          const dataWithLabels = utils.populateLabel(sortedPPS, this.state);
          const selectedValues = window.location.search ? utils.refineFiltersFromQueryString(getQueryStringFromUrl(), content.facets) : [];
          const dataAugmentedWithDefaultSelections = utils.markSelectedItems(dataWithLabels, [].concat(...selectedValues));
          resolve(dataAugmentedWithDefaultSelections);
        }
      );
    });
  };

  resetPage = () => {
    this.setState({
      resetPage: Math.random(),
      hits: [],
      hasMore: true
    });
  };

  setAlgoliaClient = (algoliaToken) => {
    const { appId, indexName, apiKey } = this.props;
    const { sortValue } = this.state;
    this.client = Algolia.search(appId, algoliaToken || apiKey);
    let newIndexName = sortValue.value;
    if (sortValue.value !== indexName) {
      newIndexName = `${indexName}_${sortValue.value}`;
    }
    this.index = this.client.initIndex(newIndexName);
  };

  updateUrlWithSortValue = (sortValue) => {
    const { indexName } = this.props;
    const newSortValue = sortValue === indexName ? 'default' : sortValue;
    window.history.replaceState(
      {},
      null,
      `${window.location.pathname}?${qs.stringify(utils.constructQueryParamWithExistingQueryParams(
        'sort',
        newSortValue,
        getQueryStringFromUrl()
      ))}`
    );
  };

  sortOnChange = (selectedValue) => {
    this.updateUrlWithSortValue(selectedValue.value);
    this.setState(
      {
        sortValue: selectedValue
      },
      () => {
        this.setAlgoliaClient();
        this.resetPage();
      }
    );
  };

  onSearchStateChange = () => {
    const { searchState, hasFilterOnlyApplied } = this.state;
    const search = refineSearchQueryState(window.location?.search?.slice(1));
    if (search && hasFilterOnlyApplied) {
      this.removeSearchParamFromUrlQueryParams();
    }
    window.history.replaceState(
      {},
      null,
      `${window.location.pathname}?${qs.stringify(utils.constructQueryParamWithExistingQueryParams(
        'query',
        searchState.query,
        getQueryStringFromUrl()
      ))}`
    );
  };

  removeSearchParamFromUrlQueryParams = () => {
    // Search param in url is used to restrict the searching criteria to only one field e.g. company name in case of company representatives
    window.history.replaceState(
      {},
      null,
      `${window.location.pathname}?${qs.stringify(utils.constructQueryParamWithExistingQueryParams(
        'search',
        '',
        getQueryStringFromUrl()
      ))}`
    );
  };

  onFilterUpdate = (data) => {
    const { id } = this.state;
    const { selected, filterData } = data;
    const filterQuery = utils.getAlgoliaFilterQuery(filterData, this.state, this.props.networkFollowees);
    this.removeSearchParamFromUrlQueryParams();
    this.updateUrlWIthFilterRefinements(filterQuery);

    this.setState({
      selectedFilter: selected.map((i) => i[id]),
      resetPage: Math.random(),
      hits: [],
      hasMore: true,
      filterQuery
    });
  };

  updateUrlWIthFilterRefinements = (facetFilters) => {
    window.history.replaceState(
      {},
      null,
      `${window.location.pathname}?${qs.stringify(utils.constructUrlParamsWithSelectedFilters(facetFilters, getQueryStringFromUrl()))}`
    );
  };

  setSearchParams = (search, searchedText, hasFilterOnlyApplied, pageNo) => {
    const { eventEditionId, context } = this.props;
    const isNewIndex = isNewAlgoliaIndexEnabled(eventEditionId);
    const params = {
      page: pageNo,
      facetFilters: this.state.filterQuery,
      hitsPerPage: AlgoliaConstants.hitsPerPage
    };
    if (isNewIndex) {
      params.filters = `locale:${context.interfaceLocale.toLowerCase()} AND eventEditionId:${eventEditionId}`;
    }
    let indexOfFilterOnlyAttribute;
    if (search && searchedText && !hasFilterOnlyApplied) {
      const searchString = JSON.stringify(searchedText);
      const filterString = `${search}:${searchString}`;
      if (params.filters) {
        params.filters = `${params.filters} AND ${filterString}`;
      } else {
        params.filters = filterString;
      }
      indexOfFilterOnlyAttribute = existingFacetingAttributes.findIndex((element) => element.includes(search));
      this.setState({ hasFilterOnlyApplied: true });
    } else {
      params.query = searchedText;
    }
    return { params, indexOfFilterOnlyAttribute };
  };

  loadItems = (pageNo) => {
    const searchedText = this.state.searchState.query;
    const { hasFilterOnlyApplied } = this.state.hasFilterOnlyApplied;
    const search = refineSearchQueryState(window.location?.search?.slice(1));

    const { params, indexOfFilterOnlyAttribute } = this.setSearchParams(search, searchedText, hasFilterOnlyApplied, pageNo);
    this.setState({ hasMore: false });
    if (authorizationStore.getToken()) {
      if (search === 'exhibitingOrganisation.displayName' && (indexOfFilterOnlyAttribute < 0) && searchedText) {
        existingFacetingAttributes = ['organisationType', 'profileResponses.questionId', 'profileResponses.answers.id', 'ppsFilterData',
          'featureFilters.multilingualNames.name', 'userId', 'filterOnly(exhibitingOrganisation.displayName)'];
        this.index.setSettings({
          attributesForFaceting: existingFacetingAttributes
        });
      }
      this.index.search(
        params,
        (err, content) => (err
          ? (() => {
            if (err.statusCode === 400) {
              AlgoliaTokenService.renewAlgoliaToken(this.props.baseApiUrl, this.props.context.eventEditionId, this.props.context.interfaceLocale)
                .then((response) => {
                  this.setAlgoliaClient(response.result);
                  this.loadItems(pageNo);
                }).catch((errors) => {
                  this.setState({ hasMore: false, hasError: true });
                  logger.logWarn(`Error From Algolia Wrapper while accessing: ${this.props.baseApiUrl}`, errors, this.props.baseApiUrl);
                });
            }
          })()
          : this.handleResponse(content, pageNo))
      );
    } else {
      this.setState({ hasMore: false, hasError: true });
    }
  };

  handleResponse = (response, pageNo) => {
    const { hits } = response;
    const { baseApiUrl, context } = this.props;
    const updatedHits = this.state.pageStart + 1 === pageNo ? hits : this.state.hits.concat(hits);
    const hasMore = updatedHits.length < response.nbHits;
    this.setState(
      {
        hasMore,
        hits: updatedHits,
        total: response.nbHits,
        hasError: false
      },
      () => {
        if (hits.length) {
          CommonService.getParticipantsWithPhotoUrls(
            hits,
            baseApiUrl,
            context.interfaceLocale
          ).then((hitsWithImages) => {
            const data = [...this.state.hits];
            data.forEach((hit, index) => {
              const found = hitsWithImages.find((hitWithImage) => hitWithImage.id === hit.id);
              if (found) {
                data[index] = found;
              }
            });
            this.setState({ hits: data });
          });
        }
      }
    );
  };

  generateParticipantList(hits) {
    const {
      context, navigation, assets, baseApiUrl, showPlan, showPlanningEnabled, isAnonymousRegistrationEnabled,
      digitalPortfolioId, digitalPortfolioName, networkFollowees, updateFolloweeList, isNetworkParticipant, loggedInUserId
    } = this.props;
    return hits.map((participant) => (
      <ParticipantItem
        key={participant.id}
        data={participant}
        navigationUrl={navigation.participantProtectedDetails}
        companyDetailUrl={navigation.participantCompanyMixedDetails}
        dtmTag={Tags.participantDirectory}
        context={context}
        assets={assets}
        baseApiUrl={baseApiUrl}
        showPlan={showPlan}
        showPlanningEnabled={showPlanningEnabled}
        digitalPortfolioId={digitalPortfolioId}
        digitalPortfolioName={digitalPortfolioName}
        networkFollowees={networkFollowees}
        updateFolloweeList={updateFolloweeList}
        isNetworkParticipant={isNetworkParticipant}
        loggedInUserId={loggedInUserId}
        isAnonymousRegistrationEnabled={isAnonymousRegistrationEnabled}
      />
    ));
  }

  render() {
    const { hits, hasError } = this.state;
    const { context } = this.props;
    const translation = TranslationService.getTranslations(context.interfaceLocale);
    const pageTitle = decodeURIComponent(window?.reactSettingsParticipantDirectory?.props?.context?.title) || '';
    const searchConfig = {
      resetText: translation.directory.filterResetText,
      appliedFilterText: translation.directory.filterApplied,
      searchBarPlaceHolder: translation.directory.search.placeholder
    };
    const totalRecordsConfig = {
      total: this.state.total || 0,
      suffix: translation.directory.search.suffix,
      prefix: {
        showing: `{n} ${translation.directory.search.suffix}`,
        mobileFilterContracted: translation.directory.search.prefix
      },
      dataDtm: Tags.search.resultCount
    };

    if (hasError) {
      return <InlineLoginError translations={translation} mustLogIn />;
    }

    return (
      authorizationStore.getToken()
        ? (
          <CustomSearch.CustomAlgoliaComponent
            {...this.props}
            {...this.state}
            searchConfig={searchConfig}
            onFilterUpdate={this.onFilterUpdate}
            fetchFilterData={this.fetchFilterData}
            loadItems={this.loadItems}
            onSearch={this.onSearch}
            sortOnChange={this.sortOnChange}
            dtmTags={Tags.participantDirectory}
            filterTitle={translation.directory.filterTitle}
            totalRecordsConfig={totalRecordsConfig}
            sortTitle={translation.directory.sortTitle}
            sortDoneText={translation.directory.sortDoneText}
            pageTitle={pageTitle}
            facets={translation.facets}
            facetToBeExcluded={NetworkingFacet.networking}
            maskedName={NetworkingFacet.participantsInMyNetwork}
            logger={loggerInstance}
          >
            {this.generateParticipantList(hits)}
          </CustomSearch.CustomAlgoliaComponent>
        ) : <InlineLoginError translations={translation} mustLogIn />
    );
  }
}

AlgoliaWrapper.propTypes = {
  baseApiUrl: PropTypes.string.isRequired,
  eventEditionId: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  appId: PropTypes.string.isRequired,
  indexName: PropTypes.string.isRequired,
  apiKey: PropTypes.string.isRequired,
  navigation: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  assets: PropTypes.object.isRequired,
  showPlan: PropTypes.object.isRequired,
  showPlanningEnabled: PropTypes.bool.isRequired,
  digitalPortfolioId: PropTypes.string,
  digitalPortfolioName: PropTypes.string,
  updateFolloweeList: PropTypes.func,
  networkFollowees: PropTypes.arrayOf(PropTypes.object),
  isNetworkParticipant: PropTypes.bool,
  loggedInUserId: PropTypes.string,
  isAnonymousRegistrationEnabled: PropTypes.bool.isRequired
};

export default AlgoliaWrapper;
